<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentExpenseStatus === 'Y'
              ? 'success'
              : row.shipmentExpenseStatus === 'S'
              ? 'warning'
              : row.shipmentExpenseStatus === 'D' ||
                row.shipmentExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_shipmentExpenseStatus }}
        </el-tag>
      </template>
      <template v-slot:currencyAmount="{ row }">
        <span
          >{{ row.v_currencyAmount || 0 }}
          {{ row.v_currencyUnit || '' }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.shipmentExpenseCode },
                  query: { shipmentExpenseNo: row.shipmentExpenseNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="
              allow('M') &&
                (row.shipmentExpenseStatus === 'N' ||
                  row.shipmentExpenseStatus === 'R')
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.shipmentExpenseCode },
                  query: { shipmentExpenseNo: row.shipmentExpenseNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="
              allow('D') &&
                (row.shipmentExpenseStatus === 'N' ||
                  row.shipmentExpenseStatus === 'R')
            "
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.tips_submit_oa_os_approval') || '提交OA审核'"
            placement="top"
            v-if="
              allow('T') &&
                (row.shipmentExpenseStatus === 'N' ||
                  row.shipmentExpenseStatus === 'R')
            "
          >
            <i class="el-icon-s-check tool-btn" @click="oaAudit(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'上传回单'"
            placement="top"
            v-if="allow('U') && row.shipmentExpenseStatus === 'Y'"
          >
            <i
              class="el-icon-folder-add tool-btn"
              @click="$emit('uploadReceipt', row)"
            >
            </i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ shipmentExpenseCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .shipmentExpenseDelApi({ shipmentExpenseCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    oaAudit({ shipmentExpenseCode }) {
      this.$confirm(
        this.$l('confirm_title_oaAudit') || '是否提交到OA审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const linkUrl = this.$joinURL(
          `/opview/shipment/expense/${shipmentExpenseCode}`,
          {
            joinOrigin: true,
            joinBasePath: false,
          }
        )
        this.loadingOpen()
        this.$api
          .shipmentExpenseSubmitOaApplyApi({ shipmentExpenseCode, linkUrl })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_submission_failed') || '提交失败！'
            )
          })
      })
    },
  },
}
</script>
